import { Typography } from "@mui/material";
import { useMemo } from "react";

import { PrescriptionCard } from "./PrescriptionCard";

export interface IPrescriptionPatientCardProps {
  name?: string;
  email?: string;
  phone?: string;
}

export const PrescriptionPatientCard = ({
  name,
  email,
  phone,
}: IPrescriptionPatientCardProps) => {
  const persistedStyle = useMemo(
    () => ({
      className: "break-words",
      sx: { fontWeight: 600 },
    }),
    [],
  );
  const patientInformation = useMemo(
    () => [
      {
        label: "Name",
        value: <Typography {...persistedStyle}>{name ?? "N/A"}</Typography>,
      },
      {
        label: "Email",
        value: <Typography {...persistedStyle}>{email ?? "N/A"}</Typography>,
      },
      {
        label: "Phone",
        value: <Typography {...persistedStyle}>{phone ?? "N/A"}</Typography>,
      },
    ],
    [email, name, persistedStyle, phone],
  );
  return (
    <PrescriptionCard
      title="Patient Information"
      items={patientInformation}
      onViewAction={() => {}}
      actionButtonText="View Patient"
    />
  );
};
